import {
  CustomerGroupPicker,
  EntityGroupPickerProps,
} from '@work4all/components/lib/components/entity-picker/entity-group-picker/EntityGroupPicker';

export type CustomerGroupPickerWrapperProps = Omit<
  EntityGroupPickerProps,
  'entity' | 'includeNoGroupOption'
>;

export function CustomerGroupPickerWrapper(
  props: CustomerGroupPickerWrapperProps
) {
  const { value, onChange } = props;

  return (
    <CustomerGroupPicker
      {...props}
      value={value}
      onChange={onChange}
      includeNoneGroupOption={true}
    />
  );
}
